import { FC } from 'react';
import { GridSettingsStore } from '../store';

type RemoveStore<T extends BindStoreProps> = Omit<T, 'store'>;

export type BindStoreProps = {
  readonly store: GridSettingsStore;
};
export const withGridStore = <T extends BindStoreProps>(
  Component: FC<T>,
  store: GridSettingsStore,
): FC<RemoveStore<T>> => {
  const WithGridStore = (props: RemoveStore<T>) => {
    const innerProps = { ...props, store } as T;
    return <Component {...innerProps} />;
  };

  // Set the display name of the wrapped component for debugging purposes.
  WithGridStore.displayName = `withGridStore(${Component.displayName || Component.name})`;

  return WithGridStore;
};
